import type { HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '@lib/utils/cn';

export function Card({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div className={cn('card p-5', className)} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={cn('mb-4 flex items-center justify-between gap-3', className)}>{children}</div>
  );
}

export function CardTitle({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  return <h3 className={cn('text-lg font-semibold text-fg', className)}>{children}</h3>;
}

export function CardDescription({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  return <p className={cn('text-sm text-fg-muted mt-1', className)}>{children}</p>;
}
